import { ArticleTechnicalInfoPropertyDef, ArticleTechnicalInfoPropertyKey } from '../../constants/article-technical-info-property';

export type TechnicalRequirementClassType =
  'TechnicalRequirementsStringVO'
  | 'TechnicalRequirementsLongVO'
  | 'TechnicalRequirementsFloatVO';

export abstract class TechnicalRequirementsVO {

  public readonly propertyName: string;

  protected constructor(propertyKey: ArticleTechnicalInfoPropertyKey, public values: (number | string)[], public classType: TechnicalRequirementClassType) {
    this.propertyName = ArticleTechnicalInfoPropertyDef[propertyKey];
  }
}

export class TechnicalRequirementsLongVO extends TechnicalRequirementsVO {
  constructor(propertyKey: ArticleTechnicalInfoPropertyKey, ...values: number[]) {
    super(propertyKey, values, 'TechnicalRequirementsLongVO');
  }
}

export class TechnicalRequirementsFloatVO extends TechnicalRequirementsVO {
  constructor(propertyKey: ArticleTechnicalInfoPropertyKey, ...values: number[]) {
    super(propertyKey, values, 'TechnicalRequirementsFloatVO');
  }
}

export class TechnicalRequirementsStringVO extends TechnicalRequirementsVO {
  constructor(propertyKey: ArticleTechnicalInfoPropertyKey, ...values: string[]) {
    super(propertyKey, values, 'TechnicalRequirementsStringVO');
  }
}

export type ArticleTechnicalValueType =
  'STRING' | 'NUMBER' | 'RANGE';

export type ArticleTechnicalPropertyValueVO = {
  type: ArticleTechnicalValueType,
  unit: string,
} & (
  {
    type: 'STRING',
    value: string,
    englishValue: string,
  } | {
  type: 'NUMBER'
  value: number,
} | {
  type: 'RANGE',
  value: number,
  value2: number,
});

export type ArticleTechnicalStringValueVO = ArticleTechnicalPropertyValueVO & { type: 'STRING' };

export type ArticleTechnicalNumberValueVO = ArticleTechnicalPropertyValueVO & { type: 'NUMBER' };

export type ArticleTechnicalRangeValueVO = ArticleTechnicalPropertyValueVO & { type: 'RANGE' };

export interface ArticleWithTechnicalPropertiesDTO {
  articleId: number,
  articleNo: string,
  articleType: number,
  displayName: string,
  materialStatus: number,
  lastCall: Date,
  publicGlobal: boolean,
  properties: Record<string, ArticleTechnicalPropertyValueVO>,
}

export function isStringValue(value: ArticleTechnicalPropertyValueVO): value is ArticleTechnicalStringValueVO {
  return value.type === 'STRING';
}

export function isNumberValue(value: ArticleTechnicalPropertyValueVO): value is ArticleTechnicalNumberValueVO {
  return value.type === 'NUMBER';
}

export class ArticleWithTechnicalValuesUtils {

  public static sort(articles: ArticleWithTechnicalPropertiesDTO[]): ArticleWithTechnicalPropertiesDTO[] {
    return articles.sort((a1, a2) => a1.articleNo.localeCompare(a2.articleNo, undefined, {numeric: true}));
  }

  public static match(article: ArticleWithTechnicalPropertiesDTO, propertyName: string, value: any): boolean {
    const property = article.properties[propertyName];
    if (!property) {
      return false;
    }
    const propertyValue = property.value;
    return propertyValue === value;
  }

  public static matchWithUnit(article: ArticleWithTechnicalPropertiesDTO, propertyName: string, valueWithUnit: any): boolean {
    const property = article.properties[propertyName];
    if (!property) {
      return false;
    }
    const propertyValueWithUnit = `${ property.value } ${ property.unit }`;
    return propertyValueWithUnit === valueWithUnit;
  }
}
